import { useGetCurrentUser } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import LoadingPage from 'gcs-common/components/LoadingPage/LoadingPage';
import { Outlet } from 'react-router';

/**
 * only purpose of this component is to wait for
 * the request that checks if the user is logged in to finish
 * this component is not concerned with the result of the request
 */
const AuthProtectedRoute = () => {
  const { isPending } = useGetCurrentUser();

  if (isPending) {
    return <LoadingPage />;
  }

  return <Outlet />;
};

export default AuthProtectedRoute;
